var _style, _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCancelicon01(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16.65 16.65",
    style: {
      enableBackground: "new 0 0 16.65 16.65"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 7.62,
    y: -2.74,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.4493 8.3275)",
    className: "st0",
    width: 1.42,
    height: 22.14
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: -2.74,
    y: 7.62,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -3.4493 8.3275)",
    className: "st0",
    width: 22.14,
    height: 1.42
  })))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelicon01);
export default __webpack_public_path__ + "static/media/cancel icon-01.7c2fe720efcdf5a7d5db11f67868b693.svg";
export { ForwardRef as ReactComponent };